import { render } from "./ShiftSmallSlot.vue?vue&type=template&id=874e94f4&scoped=true"
import script from "./ShiftSmallSlot.vue?vue&type=script&lang=js"
export * from "./ShiftSmallSlot.vue?vue&type=script&lang=js"

import "./ShiftSmallSlot.vue?vue&type=style&index=0&id=874e94f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874e94f4"]])

export default __exports__